import axios from 'axios';

export const SmartshileService = () => {
  const getDataSet = (reference_id, token, limit) => {
    return axios
      .get(window.REACT_APP_API_PURE + `datasetrecord?parent=${reference_id}&page=${limit}&limit=${100}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        return { data: res.data };
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
  return {
    getDataSet,
  };
};

export default SmartshileService;
